
export const SportHouse = [
  "Nat",
  "Lulu",
  "Kevin",
  "Jenny",
  "Michael",
  "Howard",
  "Matt",
  "Bruce",
  "Josh",
  "Dom",
]

export const BoulderHouse = [
  "Angie",
  "Lyndon",
  "Ben",
  "Austin",
  "Niko",
  "Jason",
  "Claudine",
  "Jordan",
]

export const AllPeople = Array.from(new Set([...SportHouse, ...BoulderHouse]));

export const SportHouseMinusLulu = SportHouse.filter(person => person !== "Lulu");

export const BoulderHousePlusLulu = ["Lulu", ...BoulderHouse];
